<template>
  <div class="company-card flex">
    <div class="card-image">
      <w-navigation
        :object="company"
        :params="{
          name: 'CampaignPage',
          params: {
            slug: company.slug
          }
        }"
        :blank="openExternal"
        :is-link="isLink"
      >
        <template #link>
          <img
            :src="getImageUrl(company)"
            :alt="company.name"
            class="main-image"
            loading="lazy"
            @error="
              $event.target.src = require('@/assets/images/placeholder-company.svg')
            "
          />
        </template>
      </w-navigation>
    </div>
    <div class="card-info flex flex-col justify-between p-3">
      <div class="info">
        <h3 class="name text-start">{{ company.name }}</h3>
      </div>
      <div class="actions">
        <div v-if="!company.user.following">
          <p
            class="cursor-pointer flex items-center justify-end"
            @click="followCompany(company.id)"
          >
            {{ $t("general.follow") }}
            <img
              :src="require('@/assets/images/ic-follow.svg')"
              :alt="$t('wegow.altIcon')"
              class="ml-2 w-4 h-4 lazyload"
              loading="lazy"
            />
          </p>
        </div>
        <div v-else>
          <p
            class="cursor-pointer flex items-center justify-end"
            @click="unfollowCompany(company.id)"
          >
            {{ $t("general.followed") }}
            <img
              :src="require('@/assets/images/ic-unfollow.svg')"
              :alt="$t('wegow.altIcon')"
              class="ml-2 w-4 h-4"
              loading="lazy"
            />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import WNavigation from "@/components/general/ui/WNavigation";

// TODO: añadir los composables necesarios
defineProps({
  isLink: {
    type: Boolean,
    default: true
  },
  company: {
    type: Object,
    default: undefined
  },
  type: {
    type: String,
    default: ""
    // TODO: Falta definirlo (Probablemente big o small)
  },
  openExternal: {
    type: Boolean,
    default: false
  }
});
defineEmits(["follow"]);

const followCompany = () => {
  // TODO:
};

const unfollowCompany = () => {
  // TODO:
};

const getImageUrl = element => {
  if (element?.thumbnails?.s_cd) {
    return element.thumbnails.s_cd;
  } else if (element?.image_url) {
    return element.image_url;
  } else {
    return require("@/assets/images/placeholder-company.svg");
  }
};
</script>

<style scoped lang="scss">
.company-card {
  background-color: #1c1d29;
  width: 283px;
  border-radius: 5px;
  .card-image {
    width: 120px;
    height: 120px;
    img {
      width: 120px;
      height: 120px;
    }
  }
  .card-info {
    color: $white;
    width: 163px;
    .info {
      h3 {
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
      }
      p {
        font-style: normal;
        font-weight: 300;
        font-size: 10px;
        line-height: 10px;
      }
    }
    .actions p {
      color: $topaz;
    }
  }
  .main-image {
    object-fit: cover;
    border-radius: 5px 0 0 5px;
  }
}
</style>
